import { render, staticRenderFns } from "./OptionView.vue?vue&type=template&id=cb08cd50&"
import script from "./OptionView.vue?vue&type=script&lang=js&"
export * from "./OptionView.vue?vue&type=script&lang=js&"
import style0 from "./OptionView.vue?vue&type=style&index=0&id=cb08cd50&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports